import { jsx as _jsx } from "react/jsx-runtime";
import { Paper, useMediaQuery, useTheme } from "@mui/material";
export const CheckoutWrappingPaper = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(Paper, Object.assign({ id: "checkout-wrapping-paper", sx: {
            alignSelf: "center",
            width: "100%",
            maxWidth: "md",
            padding: isMobile ? theme.spacing(3, 0) : theme.spacing(5, 0),
            flexGrow: isMobile ? 1 : 0,
        } }, { children: children })));
};
